import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/profile')({
  loader: () => ({
    crumb: 'Profile',
  }),
  component: Outlet,
})
